<div class="font-weight-bold mb-3">{{ field.description }}</div>
<div class="font-weight-bold mb-3" *ngIf="field.isRequired">
  <span i18n>Required:</span> <input type="checkbox" disabled [ngModel]="field.isRequired" />
</div>

<div class="app-control-control sm-space-y-2">
  <img [src]="thumbnailSrc" alt="placeholder thumbnail for photos" draggable="false" />
  <button type="button" class="btn btn-primary disabled sm-cursor-grab" i18n>
    Add photos <i class="cc-icon cc-icon-photo sm-pl-1"></i>
  </button>
</div>
